import React, { useCallback, useMemo, useRef, useState } from 'react';
import { relative } from 'path';
import DotIcon from '../../assets/icons/DotIcon';
import { COLORS } from '../../styles/variables';
import InfoPopover from '../InfoPopover';
import getMarket from '../../utils/getMarket';
import { RadioWrapper, Label, Radio, HiddenInput, Count } from './RadioButtonSelector.styles';
import Popover from '../PopOver';
import { IconWrapper } from '../Filters/Filters.style';
import InfoIcon from '../../assets/icons/Info';
import QuestionMarkIcon from '../../assets/icons/QuestionMarkIcon';

interface OptionProps {
  name: string;
  value?: string;
  label?: string | React.ReactNode;
  count?: number;
  ariaLabel?: string;
  disabled?: boolean;
  onChange: (isNonAudiFilter: boolean | undefined, option: string) => void;
  checked: boolean;
  popoverTitle?: string;
  popoverDescription?: string;
  isNonAudiFilter?: boolean;
}

const Option: React.FC<OptionProps> = ({
  value,
  onChange,
  name,
  label,
  count,
  ariaLabel,
  disabled = false,
  checked,
  popoverTitle,
  popoverDescription,
  isNonAudiFilter,
}) => {
  const inputName = `${name}-${value}`;
  const handleChange = useCallback(() => {
    if (!disabled && value) onChange(isNonAudiFilter, value);
  }, [disabled, value, onChange, isNonAudiFilter]);

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key !== ' ') return;
      e.preventDefault();
      handleChange();
    },
    [handleChange],
  );

  const optionRef = useRef(null);
  const iconRef = useRef(null);

  const position = {
    container: { bottom: '-86px' },
    arrow: {
      left: '68%',
    },
  };

  const countString = count?.toString();

  return (
    <RadioWrapper disabled={disabled} ref={optionRef}>
      <Radio
        tabIndex={0}
        onClick={handleChange}
        role="radio"
        aria-label={ariaLabel}
        aria-checked={checked}
        onKeyDown={handleKeyPress}
        checked={checked}
      >
        {checked ? <DotIcon color={COLORS.grey80} /> : <DotIcon color={COLORS.grey15} size={8} />}
      </Radio>
      <HiddenInput
        id={inputName}
        type="radio"
        onChange={handleChange}
        checked={checked}
        name={inputName}
      />
      <Label htmlFor={inputName}>
        {label}
        {countString && <Count>({countString})</Count>}
        {popoverDescription && (
          <InfoPopover
            title={popoverTitle}
            description={popoverDescription}
            iconColor={COLORS.black}
            iconSize={24}
            vehicleTypeIconWrapper
            iconElevated
            IconWrapperSize={24}
          />
        )}
      </Label>
    </RadioWrapper>
  );
};

export default Option;
